const Color = {
  white: function () {
    return "white";
  },
  green: function () {
    return "#3fb156";
  },
  gray: function () {
    return "#818a97";
  },
  darkGray: function () {
    return "#353c43";
  },
  red: function () {
    return "#e52b20";
  },
  blue: function () {
    return "#335cda";
  },
  lightOrange: function () {
    return "#fdf4e7";
  },
  orange: function () {
    return "#ee9412";
  },
  borderColor: function () {
    return "#ececee";
  },
  backgroundColor: function () {
    return "#ebeef1";
  },
  disabledTextColor: function () {
    return "#6F7079";
  },
  disabledInputColor: function () {
    return "#F3F5F7";
  },
  disabledBorderColor: function () {
    return "#cbd2dc";
  },
  blueHoverColor: function () {
    return "#143d93";
  },
};
export default Color;